export const LOAN_SUMMARY_PROPORTION_CHART_PERSONAL_REAL_ESTATE_LOANS_COLOR = '#D2FFED';
export const LOAN_SUMMARY_PROPORTION_CHART_INVESTMENT_REAL_ESTATE_LOANS_COLOR = '#66FFC2';
export const LOAN_SUMMARY_PROPORTION_CHART_STUDENT_LOANS_COLOR = '#016E42';
export const LOAN_SUMMARY_PROPORTION_CHART_OTHER_DEBT_COLOR = '#003A20';
export const LOAN_SUMMARY_PROPORTION_CHART_CREDIT_CARD_DEBT_COLOR = '#00A055';
export const LOAN_SUMMARY_PROPORTION_CHART_AUTO_LOANS_DEBT_COLOR = '#00F682';
